import React from "react";
import FinDocListPage from "../components/FinDocListPage";
import { queryIsAuditFinDoc } from "../newApi/findoc.api";

export default function FinDocAudited() {
  return (
    <FinDocListPage
      title="已簽核"
      menuKey="FinDocAudited"
      defaultStatuses={[]}
      fetcher={queryIsAuditFinDoc}
      getActions={(record, actor, navigate) => [
        {
          label: "檢視",
          onClick: () => navigate(`/FinDoc/View/${record.findoc_no}`),
        },
      ]}
    />
  );
}